import { createStyles, rem } from "@mantine/core"

export const useStyles = createStyles(
    (theme, { isCentered, isSubtitle }: { isCentered: boolean; isSubtitle: boolean }) => ({
        title: {
            color: theme.colors.gray[7],
            textAlign: isCentered ? "center" : "unset",
            fontFeatureSettings: `'clig' off, 'liga' off`,
            fontSize: isSubtitle ? rem(16) : rem(18),
            fontStyle: "normal",
            fontWeight: isSubtitle ? 400 : 500,
            lineHeight: "145%",
        },
        description: {
            color: theme.colors.gray[7],
            textAlign: isCentered ? "center" : "unset",
            fontFeatureSettings: `'clig' off, 'liga' off`,
            fontSize: rem(16),
            fontStyle: "normal",
            fontWeight: 400,
            lineHeight: "150%",
        },
        container: {
            gap: rem(8),
            display: "flex",
            flexDirection: "column",
        },
    }),
)
